"use strict";

exports.__esModule = true;
exports["default"] = hideText;

function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./~/polished/lib/mixins/hideText.js
// module id = 1026
// module chunks = 27180705640166